export default __webpack_public_path__ + "static/media/manual-download-crop-hover.8ad38daa.png";